import CentreOverlay from "components/CentreOverlay";
import Spinner from "components/Spinner";

interface LoadingProps {
  dataTestId: string;
}

export const Loading = ({ dataTestId }: LoadingProps) => {
  return (
    <CentreOverlay data-testid={dataTestId}>
      <Spinner />
    </CentreOverlay>
  );
};
